import type { PropsWithChildren } from 'react'

import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

interface TooltipCellProps extends PropsWithChildren {
  title: string
  className?: string
}
export const TooltipCell = ({ title, children, className }: TooltipCellProps) => {
  return (
    <Tooltip>
      <TooltipTrigger className={cn('max-w-full truncate text-left', className)}>{children}</TooltipTrigger>
      <TooltipContent className='max-w-120'>
        <p>{title}</p>
      </TooltipContent>
    </Tooltip>
  )
}
